import { Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/** Order metadata only: never a control or a replacement for bin state colours. */
export function ExpressBadge({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' }) {
  const { t } = useTranslation('production');

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded font-semibold',
        // sm = inside a bin tile: must not change the tile height, so rows stay aligned.
        size === 'sm' ? 'gap-1 px-1.5 py-[3px] text-[11px] leading-4' : 'gap-1 px-2 py-1 text-base leading-5',
        'bg-sky-100 text-sky-900 dark:bg-sky-900 dark:text-sky-100',
        className,
      )}
      role="img"
      aria-label={t('bins.expressLabel')}
    >
      <Zap className={cn('shrink-0', size === 'sm' ? 'h-3 w-3' : 'h-4 w-4')} aria-hidden="true" />
      <span aria-hidden="true">{t('bins.express')}</span>
    </span>
  );
}
